export default {
  tableHeader: 'Signály zariadenia',
  showHidden: 'Zobraziť skryté signály zariadenia',
  overFlowMenu: {
    tooltip: 'Ďalšie funkcie',
    export: 'Exportovať nastavenia snímača',
    import: 'Importovať nastavenia snímača',
  },
  placeholder: {
    meaningId: 'Vybrať význam',
    meaningInstanceNumber: 'Číslo inštancie',
  },
};
